import { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import Grid, { GridColumn, GridHeader, GridRow } from "../../../components/Grid/Grid";
import { useDispatch } from "react-redux";
import HelperService from "../../../utility/HelperService";
import { useSelector } from "react-redux";
import { permissionsInterface } from "../../onBoarding/onBoardingTypes";
import PageTitle from "../../../components/PageTitle/PageTitle";
import { Pencil, Plus, Trash } from "react-bootstrap-icons";
import routePaths from "../../../Navigation/routePaths";
import DeleteModal from "../../../components/DeleteModal/DeleteModal";
import WebService from "../../../utility/WebService";
import { toast } from "react-toastify";
import { PiExport } from "react-icons/pi";

const headers: GridHeader[] = [
  {
    title: "Date",
    class: "text-left",
    isSorting: true,
    isAsc: true,
    sortingKey: "created_at",
  },
  {
    title: "Project name",
    class: "text-left",
    isSorting: true,
    isAsc: true,
    sortingKey: "project.project_name",
  },
  {
    title: "Expense Type",
    class: "text-left",
    isSorting: true,
    isAsc: true,
    sortingKey: "expense_type",
  },
  {
    title: "SubExpense Type",
    class: "text-left",
    isSorting: true,
    isAsc: true,
    sortingKey: "sub_expense_type",
  },
  {
    title: "Amount",
    class: "text-left",
    isSorting: true,
    isAsc: true,
    sortingKey: "amount",
  },
  {
    title: "Payment mode",
    class: "text-left",
  },
  {
    title: "Comment",
    class: "text-left",
  },
  {
    title: "Action",
    class: "text-center freeze-column",
    headerClass: "text-center",
    isSorting: false,
    isFilter: false,
    isFreeze: true,
  },
];

const Expenses = () => {
  const navigate = useNavigate();
  const nextOffset = useRef<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [expenseId, setExpenseId] = useState<string>("");
  const [showDeleteModal, setDeleteModal] = useState<boolean>(false);
  const [rows, setRows] = useState<GridRow[]>([]);
  const rowCompute = useRef<GridRow[]>([]);
  const [showHiddenFields, setShowHiddenFields] = useState<boolean>(false);
  const [pressedKeys, setPressedKeys] = useState(new Set());
  const [expenseCount, setExpenseCount] = useState<number>(0);
  const token = useSelector((state: any) => state.OnBoardingReducer);
  const [permissions, setPermissions] = useState<permissionsInterface | null>(null);
  const [startDate, setStartDate] = useState<Date | any>("");
  const [endDate, setEndDate] = useState<Date | any>("");
  const [keyword, setKeyword] = useState<string>("");
 

  useEffect(() => {
    if (token && token.token && token.permissions && !!token.permissions.length) {
      setPermissions(token.permissions.find((item: any) => item.name === "EXPENSES"));
     
    }
  }, [token])

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
    };
  }, [pressedKeys]);

  useEffect(() => {
    showHiddenFields && getExpenseList(1);
  }, [showHiddenFields]);

  const actionList = (data: any) => {
    return (
      <div className="action-btns">
        {permissions && permissions.can_update && <button
          className="cursor-pointer  btn-edit btn"
          onClick={() => onEdit(data)}
        >
          {" "}
          <Pencil />{" "}
        </button>}
        {permissions && permissions.can_delete && <button
          onClick={() => onConfirmDelete(data)}
          className="cursor-pointer btn btn-delete"
        >
          {" "}
          <Trash />{" "}
        </button>}
      </div>
    );
  };

  const onEdit = (val: any) => {
    setExpenseId(val);
    navigate("/update-expense/" + val, { state: { type: showHiddenFields ? "REAL" : "FAKE" } });
  };

  const onConfirmDelete = (val: any) => {
    setExpenseId(val);
    setDeleteModal(true);
  };

  const getExpenseList = (
    offset: number,
    keyword?: string,
    startDate?: Date,
    endDate?: Date,
    order_by?: string,
    sort_by?: string
  ) => {
    nextOffset.current = offset;
    if (nextOffset.current < 0 || isLoading) {
      return;
    }
    setIsLoading(true);
    WebService.getAPI({
      action: `expense/pagination/list?limit=10&offset=${offset > 0 ? offset - 1 : 0}&keyword=${keyword ? keyword : ""
        }&sort_by=${order_by ?? "asc"}&order_by=${sort_by ?? "created_at"}&from_date=${startDate ? startDate : ""}&to_date=${endDate ? endDate : ""
        }`,
      body: null,
      is_session: showHiddenFields
    })
      .then((res: any) => {
        setIsLoading(false);
        setStartDate(startDate ?? "");
        setEndDate(endDate ?? "");
        setKeyword(keyword ?? "");
        let rows: GridRow[] = [];
        setExpenseCount(res.count);
        for (var i in res.list) {
          let columns: GridColumn[] = [];
          columns.push({ value: res.list[i].payment_date && HelperService.getFormatedDate(res.list[i].payment_date), });
          columns.push({ value: res.list[i]?.project?.project_name ? res.list[i].project?.project_name : "N/A", });
          columns.push({ value: res.list[i]?.expense_type?.name ? res.list[i]?.expense_type?.name : "N/A", });
          columns.push({ value: res.list[i]?.sub_expense_type?.name ? res.list[i]?.sub_expense_type?.name : "N/A", });
          columns.push({ value: res.list[i].amount ? res.list[i].amount : "N/A", });
          columns.push({
            value: res.list[i].payment_mode_detail
              ? `${res.list[i].payment_mode_detail?.name} ${res.list[i].payment_mode_detail?.bank_name ? `(${res.list[i].payment_mode_detail?.bank_name})` : ""}`
              : "N/A",
          });
          columns.push({ value: res.list[i].comment ? res.list[i].comment : "N/A", });
          columns.push({ value: actionList(res.list[i].uuid), type: "COMPONENT", });
          rowCompute.current.push({ data: columns });
          rows.push({ data: columns });
        }
        rowCompute.current = rows;
        setRows(rowCompute.current);
      })
      .catch((e) => {
        setIsLoading(false);
      });
  };

  const onSortList = (offset: number, isAscending?: boolean, key?: string) => {
    getExpenseList(
      offset,
      null as any,
      null as any,
      null as any,
      isAscending ? "asc" : "desc",
      key
    );
  };

  const onDelete = () => {
    setDeleteModal(false);
    setIsLoading(true);
    WebService.deleteAPI({
      action: `expense/delete/${expenseId}`,
      body: null,
    })
      .then((res: any) => {
        setIsLoading(false);
        toast.success(res.message);
        setExpenseId("");
        getExpenseList(1);
      })
      .catch((e) => {
        setIsLoading(false);
        setExpenseId("");
      });
  };

  const handleKeyDown = (e: any) => {
    const key = e.key.toLowerCase();
    setPressedKeys((prev: any) => new Set([...prev, key]));
  };

  const handleKeyUp = (e: any) => {
    const key = e.key.toLowerCase();
    if (pressedKeys.has('control') && pressedKeys.has('alt') && pressedKeys.has('o') && pressedKeys.has('p')) { setShowHiddenFields(true); }
    setPressedKeys((prev: any) => { const updated = new Set(prev); updated.delete(key); return updated; });
  };

  const exportExpenses = () => {
    WebService.getAPI({
      action: `expense/export?keyword=${keyword ? keyword : ""}&from_date=${startDate ? startDate : ""}&to_date=${endDate ? endDate : ""}`,
      body: null,
      is_session: showHiddenFields,
      responseType: 'arraybuffer',
    }).then((response: any) => {
      const url = window.URL.createObjectURL(new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `expenses_${new Date().toISOString()}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    }).catch((e) => {
      toast.error("Failed to export expenses");
    });
  };




  return (
    <>
      <DeleteModal
        isShow={showDeleteModal}
        close={() => {
          setDeleteModal(false);
        }}
        onDelete={() => {
          onDelete();
        }}
      />
      {permissions && permissions.can_read && <div className="app-page page-dashboard">
        <div className="d-flex justify-content-between align-items-center ">
          <PageTitle title="Expenses" backArrow={false} active={showHiddenFields} />
          <div>
            {permissions && permissions.can_write && <Button
              className="btn btn-brand-1 mb-3"
              onClick={() => navigate(routePaths.EXPENSE_CREATE.path)}
            >
              {" "}
              <Plus size={20} className="ms-1" /> Add Expense
            </Button>}
            {permissions && permissions.can_write && permissions.can_update && <Button
              className="btn btn-brand-1 mb-3 ms-2"
              onClick={() => { exportExpenses(); }}
            >
              <PiExport size={20} className="ms-1" /> Export
            </Button>}
          </div>
        </div>
        <div className="table-card">
          <Grid
            rows={rows}
            showSearch={true}
            headers={headers}
            showDateFilter={true}
            onPageChange={getExpenseList}
            errorMessage={"No Expense Found"}
            ShowLoader={isLoading}
            onSort={onSortList}
            count={expenseCount}
           
          />
        </div>
      </div>}
    </>
  );
};

export default Expenses;
